// assets/cart-bulb-guard.js
document.addEventListener('DOMContentLoaded', () => {
  if (!/^\/cart(\/|$)/.test(location.pathname)) return;

  // Hinweisbox (Dark/Light lesbar)
  const info = document.createElement('div');
  info.className = 'bulb-guard-msg';
  info.style.cssText = [
    'display:none',
    'margin:12px 0',
    'padding:10px',
    'border-radius:8px',
    'border:1px solid rgba(241,196,15,.45)',
    'background:rgba(241,196,15,.12)',
    'font-size:14px'
  ].join(';');
  info.textContent = '⚠️ Glühbirnen dürfen höchstens der Lampenanzahl entsprechen. Bitte passe die Mengen an.';
  const footer = document.querySelector('.cart__footer') || document.querySelector('.page-width') || document.body;
  footer.prepend(info);



  // möglichst ALLE Checkout-Trigger erfassen
  const checkoutSelectors = [
    'button[name="checkout"]',
    'form[action="/cart"] button[type="submit"]',
    '.cart__ctas button[type="submit"]',
    '.cart__checkout',
    '[data-checkout-button]',
    '[data-checkout]',
    '[data-action="checkout"]',
    'a[href*="/checkout"]',
    'button[formaction*="/checkout"]',
    'input[type="submit"][formaction*="/checkout"]',
    'input[type="submit"][name="checkout"]'
  ];

  const getRefs = () => {
    const checkoutButtons = document.querySelectorAll(checkoutSelectors.join(','));
    const expressWrappers = document.querySelectorAll('.shopify-payment-button, .cart__dynamic-checkout-buttons');
    const expressButtons  = document.querySelectorAll('.shopify-payment-button button, .cart__dynamic-checkout-buttons button, .shopify-payment-button__button');
    const cartForm = document.querySelector('form[action="/cart"]') || document.querySelector('form[action*="/cart"]');
    return { checkoutButtons, expressWrappers, expressButtons, cartForm };
  };

  function setCheckoutDisabled(disabled) {
    const { checkoutButtons, expressWrappers, expressButtons } = getRefs();

    // Checkout: sichtbar lassen, aber deaktivieren/ausgrauen
    checkoutButtons.forEach(btn => {
      // Links bekommen kein disabled → Klasse + verhindern wir per JS
      if (btn.tagName === 'A') {
        btn.classList.toggle('is-disabled', disabled);
        btn.setAttribute('aria-disabled', String(disabled));
      } else {
        btn.disabled = disabled;
        btn.setAttribute('aria-disabled', String(disabled));
        btn.classList.toggle('is-disabled', disabled);
      }
    });

    // Express komplett ausblenden bei Regelbruch
    expressWrappers.forEach(w => w.style.display = disabled ? 'none' : '');
    expressButtons.forEach(b => { try { b.disabled = disabled; } catch(_){} });
  }

async function getCounts() {
  const cart = await fetch('/cart.js', { credentials: 'same-origin' }).then(r => r.json());

  const bulbVariantIds = [
    52838523896147, // warmweiß
    54067768164691  // kaltweiß
  ];

  let lamp = 0;
  let bulb = 0;

  for (const it of cart.items) {
    const p = it.properties || {};
    const variantId = Number(it.variant_id || it.id);

    const isBulb =
      p._addon === 'bulb' ||
      bulbVariantIds.includes(variantId) ||
      String(it.handle || '').includes('gluhbirne');

    if (isBulb) {
      bulb += it.quantity;
    } else {
      lamp += it.quantity;
    }
  }

  const invalid = bulb > lamp;

  return { lamp, bulb, invalid };
}

  async function recompute() {
    const { invalid } = await getCounts();
    if (invalid) {
      info.style.display = '';
      setCheckoutDisabled(true);
    } else {
      info.style.display = 'none';
      setCheckoutDisabled(false);
    }
    return invalid;
  }

  // initial prüfen
  recompute();
// Zusätzliche Re-Checks (fangen langsames Netz / Race Conditions ab)
setTimeout(() => recompute(), 600);
setTimeout(() => recompute(), 1500);

// Beim Zurückkommen auf die Seite erneut prüfen
window.addEventListener('pageshow', () => recompute());
document.addEventListener('visibilitychange', () => {
  if (!document.hidden) recompute();
});

  // bei Mengenänderung neu prüfen
  document.addEventListener('change', (e) => {
    const isQty = e.target && (e.target.matches('input.quantity__input') || e.target.name === 'updates[]');
    if (!isQty) return;
    setTimeout(() => recompute(), 250);
  });

  // HARTE Absicherung: alle Klicks (Buttons/Links) zum Checkout abfangen
  document.addEventListener('click', async (e) => {
    const target = e.target;
    const trigger = target.closest(checkoutSelectors.join(','));
    if (!trigger) return;

    const invalid = await recompute();
    if (invalid) {
      e.preventDefault();
      e.stopPropagation();
      alert('Checkout gesperrt: Glühbirnen dürfen höchstens der Lampenanzahl entsprechen.');
    }
  }, true); // in der Capture-Phase, damit wir vor Theme-Handlern drankommen

  // Submit des Warenkorb-Forms abfangen
  const { cartForm } = getRefs();
  if (cartForm) {
    cartForm.addEventListener('submit', async (e) => {
      const invalid = await recompute();
      if (invalid) {
        e.preventDefault();
        alert('Checkout gesperrt: Glühbirnen dürfen höchstens der Lampenanzahl entsprechen.');
      }
    }, true);
  }

  // Enter-Taste (z. B. Fokus auf Button/Qty-Feld) → ebenfalls blocken
  document.addEventListener('keydown', async (e) => {
    if (e.key !== 'Enter') return;
    const active = document.activeElement;
    if (!active) return;
    const trigger = active.closest(checkoutSelectors.join(','));
    if (!trigger) return;
    const invalid = await recompute();
    if (invalid) {
      e.preventDefault();
      e.stopPropagation();
    }
  }, true);

  // Falls Theme nachlädt → erneut prüfen
  const mo = new MutationObserver(() => recompute());
  mo.observe(document.body, { childList: true, subtree: true });
});
